export const BADGE_CONSTS = {
    GET_BADGES: "GET_BADGES",
    CREATE_BADGE: "CREATE_BADGE",
    UPDATE_BADGE: "UPDATE_BADGE",
    DELETE_BADGE_BY_ID: "DELETE_BADGE_BY_ID",
};
